'use strict';

import get from 'lodash/get';
import { isArray, isEmpty, isNumber } from 'lodash';

const parenthesesRegex = /\(([A-Z\s]+)\)/;

// helper function for finding text inside parentheses.
export const getInsideParentheses = (str) => {
  if (str) {
    let result = parenthesesRegex.exec(str);
    if (result && result.length > 1) {
      // if found, return first match of tag inside parentheses
      return result[1];
    }
  }
  return null;
};

/**
 * Lodash get is implemented so that an undefined value only returns default.
 * This function extends the previous so that null values also return the
 * default value.
 *
 * @param object The object to query.
 * @param path   The path of the property to get.
 * @param defaultValue The value returned for 'undefined' or null values.
 * @returns {*} Returns the resolved value
 */
export const nonNullGet = (object, path, defaultValue) => {
  let result = get(object, path, defaultValue);
  return result === null ? defaultValue : result;
};

/**
 * Helper function for whether a placeholder should be shown.
 * If yes, return given placeholder name.
 * If not, return null.
 *
 * @param show whether placeholder should be shown
 * @param placeHolderName
 * @returns {*}
 */
export const shouldShowPlaceholder = (show, placeHolderName) => {
  return show ? placeHolderName : null;
};

/**
 * Helper function for counting notifications.
 *
 * Notifications can be either a number directly indicating the count of
 * notifications, or an array containing certain notification objects.
 * In case of array return the size of array, in case of number, return the number.
 *
 * @param notifications
 * @returns number
 */
export const getNotificationCount = (notifications) => {
  if (isArray(notifications)) {
    return notifications.length;
  } else if (isNumber(notifications)) {
    return notifications;
  }
};

export const getNotificationCountWithoutBundled = (notifications, type) => {
  let typeQuestionnaireCount =
    notifications && notifications.length > 0
      ? notifications.filter((item) => item.type === type).length
      : 0;
  return (
    (notifications ? getNotificationCount(notifications) : 0) -
    (typeQuestionnaireCount > 1 ? typeQuestionnaireCount - 1 : 0)
  );
};

/**
 * Check that array is not empty.
 *
 * @param array
 * @returns {boolean}
 */
export const notEmpty = (array) => {
  return !isEmpty(array);
};
